import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box } from '@mui/material';

export interface BillingLedgerRow {
  timestamp: number;
  model?: string;
  rateCardId?: string;
  description: string;
  change: number;
  balance: number;
}

interface BillingTableProps {
  ledgerRows: BillingLedgerRow[];
}

export function BillingTable({ ledgerRows }: BillingTableProps): JSX.Element {
  return (
    <Paper sx={{ gridColumn: { md: 'span 2' } }}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Recent Activity
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Model</TableCell>
                <TableCell>Rate</TableCell>
                <TableCell align="right">Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ledgerRows.length > 0 ? (
                ledgerRows.map((row) => (
                  <TableRow key={row.timestamp}>
                    <TableCell sx={{ whiteSpace: 'nowrap', color: 'text.secondary' }}>
                      {new Date(row.timestamp).toLocaleString([], {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      })}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.description}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', color: 'text.secondary' }}>{row.model || '—'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', color: 'text.secondary' }}>{row.rateCardId || '—'}</TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        whiteSpace: 'nowrap',
                        fontWeight: 600,
                        color: row.change >= 0 ? 'success.main' : 'error.main',
                      }}
                    >
                      {row.change >= 0 ? '+' : '-'}${Math.abs(row.change).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4, color: 'text.secondary' }}>
                    No recent activity.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  );
}
